<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Meus Planos' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <div class="div-card">
    <div class="div-top">
      <ion-note slot="start">
        <i class="fal fa-wallet div-icon"></i>
      </ion-note>

      <ion-label class="color-title"> {{'Meus planos' | translate}} </ion-label>
    </div>

    <ion-grid *ngFor="let plano of planos">
      <ion-card style="border-radius: 2rem">
        <ion-row>
          <ion-col class="remove-border">
            <ion-item>
              <ion-note slot="start">
                <i class="fal fa-wallet"></i>
              </ion-note>
              <ion-label>
                <h2 class="titulo">{{plano.plano}}</h2>
                <p class="titulo-tipo">{{plano.planoTipo}}</p>
              </ion-label>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <p class="bold-1">{{'Data de Adesão' | translate}}</p>

            <p class="two-lines">
              {{plano.dataAdesao | dateFormat:'ddmmyyyy'}}
            </p>
          </ion-col>

          <ion-col
            *ngIf="plano.parcelasFaltantes != 'recorrente' && (plano.parcelasFaltantes * 1) > 1"
          >
            <p class="bold-1">{{'Data Final' | translate}}</p>
            <p *ngIf="plano.dataFinal != 'recorrente'" class="two-lines">
              {{plano.dataFinal | dateFormat:'ddmmyyyy'}}
            </p>
            <p *ngIf="plano.dataFinal == 'recorrente'" class="two-lines">
              {{'Recorrente' | translate}}
            </p>
          </ion-col>
        </ion-row>

        <ion-row
          *ngIf="plano.parcelasFaltantes != 'recorrente' && (plano.parcelasFaltantes * 1) > 1"
        >
          <ion-col>
            <p class="bold-1">{{'Parcelas Pagas' | translate}}</p>

            <p class="two-lines">{{plano.parcelasPagas}}</p>
          </ion-col>

          <ion-col>
            <p class="bold-1">{{'Parcelas Faltantes' | translate}}</p>

            <p
              *ngIf="plano.parcelasFaltantes != 'recorrente'"
              class="two-lines"
            >
              {{plano.parcelasFaltantes}}
            </p>
            <p
              *ngIf="plano.parcelasFaltantes == 'recorrente'"
              class="two-lines"
            >
              {{'Recorrente' | translate}}
            </p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <p class="bold-1">{{'Valor Mensal' | translate}}</p>

            <p class="two-lines">{{plano.valorAtual | money | async}}</p>
          </ion-col>

          <ion-col>
            <p class="bold-1">{{'Forma de Pagamento' | translate}}</p>

            <p *ngIf="plano.formaPagamento == 'cartao'" class="two-lines">
              {{'Cartão' | translate}}
            </p>

            <p *ngIf="plano.formaPagamento == 'boleto'" class="two-lines">
              {{'Boleto' | translate}}
            </p>

            <p *ngIf="plano.formaPagamento == 'pix'" class="two-lines">
              {{'Pix' | translate}}
            </p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <p class="bold-1">{{'Status' | translate}}</p>

            <p
              *ngIf="plano.removido != '1' && plano.finalizado != '1'"
              class="bold-2 green"
            >
              {{'Ativo' | translate}}
            </p>

            <p
              *ngIf="plano.removido == '1' && plano.finalizado != '1'"
              class="bold-2 red"
            >
              {{'Cancelado' | translate}}
            </p>

            <p *ngIf="plano.finalizado == '1'" class="bold-2 orange">
              {{'Finalizado' | translate}}
            </p>
          </ion-col>

          <ion-col *ngIf="!userProvider.hasConfig(163)">
            <ion-button
              *ngIf="plano.removido == '0'"
              expand="small"
              (click)="cancelar(plano.idPlanoContribuicaoPessoa)"
              class="btn-danger"
              style="font-size: 12px !important"
            >
              {{'Cancelar Plano' | translate}}
            </ion-button>
          </ion-col>
        </ion-row>

        <ion-row class="ion-justify-content-center">
          <ion-col size="8">
            <ion-button
              class="btn-custom-icon"
              (click)="parcelas(plano)"
              expand="block"
              type="button"
            >
              <i class="fas fa-receipt"></i>
              {{'Ver Parcelas' | translate}}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-card>
    </ion-grid>
  </div>
  <sem-registro *ngIf="planos.length == 0"></sem-registro>
</ion-content>
